import * as React from 'react'
// components
import { TableRow } from '@mui/material'
import { HoverablePopover, Link } from 'components/UI'
// hooks
import { useShowModal } from 'hooks/useShowModal'
// static
import WatchLaterIcon from '@mui/icons-material/WatchLaterOutlined'
// types
import { Modals } from 'constants/modals'
import { IField, IPlanAction } from 'types/graphql'
// constants
import { Chip, ICON_STYLE, ReviewIcon, TableCell, TEXT_STYLE } from 'themes/views/tables'
// themes
import { EllipsizedText } from 'themes/views/generic'
// utils
import moment from 'moment'
import { getEntityStatus } from 'utils/fields'
import { getChipColor, getClosestReview, getOwnedBy, getPlanFromEntity } from 'utils/index'

interface Props {
  data: IPlanAction
  fields: IField[]
}

const Row: React.FC<Props> = ({ data, fields }) => {
  const { showModal } = useShowModal({ modalType: Modals.ACTION_MINIMIZED_MODAL })

  const { id, description, fieldValueMap, ownedByUser, ownedByPosition, completionAt, completionPercentage } = data

  const plan = getPlanFromEntity(data)
  const ownedBy = getOwnedBy(ownedByPosition, ownedByUser)
  const closestReview = getClosestReview(data)
  const isActionComplete = completionPercentage === 100
  const chipLabel = isActionComplete ? 'Done' : completionAt ? moment(completionAt).format('D MMM YY') : 'No data set'

  const showActionModal = () => showModal({ id })

  return (
    <TableRow hover>
      <TableCell size={30} withEllipsis>
        <HoverablePopover
          trigger={
            <EllipsizedText onClick={showActionModal} style={TEXT_STYLE}>
              {description}
            </EllipsizedText>
          }>
          {description}
        </HoverablePopover>
      </TableCell>
      <TableCell size={10}>{getEntityStatus(fieldValueMap, fields) || 'N/A'}</TableCell>
      <TableCell size={30} withEllipsis>
        <HoverablePopover
          trigger={
            <EllipsizedText>
              <Link
                href={{
                  pathname: `/plans/${plan.companyId}/edit/${plan.id}`,
                  query: {
                    ...(plan.parentPlanId && { parentId: plan.parentPlanId })
                  }
                }}>
                {plan.name}
              </Link>
            </EllipsizedText>
          }>
          {plan.name}
        </HoverablePopover>
      </TableCell>
      <TableCell size={5}>
        <Chip
          rounded
          label={chipLabel}
          chipColor={getChipColor(completionAt, completionPercentage)}
          icon={completionAt ? <WatchLaterIcon style={ICON_STYLE} /> : null}
        />
      </TableCell>
      <TableCell size={5}>
        <Chip
          rounded
          icon={closestReview ? <ReviewIcon /> : null}
          chipColor={getChipColor(closestReview?.dueDate, closestReview?.status)}
          label={closestReview ? closestReview.dueDate.format('D MMM YY') : 'No review'}
        />
      </TableCell>
      <TableCell size={20}>{ownedBy}</TableCell>
    </TableRow>
  )
}

export default Row
